import { render, staticRenderFns } from "./TestSetting.vue?vue&type=template&id=49aea353&"
import script from "./TestSetting.vue?vue&type=script&lang=js&"
export * from "./TestSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports